import { render, staticRenderFns } from "./AgendaFilter.vue?vue&type=template&id=58ecf916"
import script from "./AgendaFilter.vue?vue&type=script&lang=js"
export * from "./AgendaFilter.vue?vue&type=script&lang=js"
import style0 from "./AgendaFilter.vue?vue&type=style&index=0&id=58ecf916&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports